module.exports = __webpack_public_path__ + "static/media/facebook_messenger.bb5ffb34.svg";